module.exports = __webpack_public_path__ + "static/media/013-computer-1.251cc60b.svg";